import { indexItems } from '@/mocks/homeData';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block text-xs font-medium text-accent-600 bg-accent-100/70 px-3 py-1 rounded-full mb-3">
            内容导航
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">专题索引</h2>
          <p className="text-sm text-foreground-600 mt-2">按话题分类浏览，快速找到你感兴趣的爆料专题</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item) => (
            <div
              key={item.title}
              className="flex items-start gap-4 p-5 rounded-xl bg-background-100 border border-background-200/70 cursor-pointer hover:border-primary-200 transition-colors group"
            >
              <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center shrink-0">
                <i className={`${item.icon} text-lg text-accent-500`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-sm font-semibold text-foreground-900">{item.title}</h3>
                  <span className="text-xs text-foreground-400 whitespace-nowrap">{item.count}</span>
                </div>
                <p className="text-xs text-foreground-600 leading-relaxed line-clamp-2">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}